export function notZero() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.required = modelValue => {

                if (!modelValue) {

                    return false;
                }

                return parseFloat(modelValue) !== 0;
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/not-zero.directive.js